/**
 * @fileoverview User Permissions definitions
 */

export const Permissions = Object.freeze({
  ADMIN: 'administrator',
  ACCOUNTANT: 'accountant', 
  DISPATCHER: 'dispatcher',
  FOREMAN: 'foreman',
  PROJECT_MANAGER: 'project_manager',
  SCHEDULER_EDIT: 'scheduler_edit',
  SCHEDULER_VIEW: 'scheduler_view',
  EMPLOYEE: 'employee', // Default fallback permission
})